var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#56355B;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372.5,391.1c-0.9-9.2-4.8-16.3-11.7-21.4c-6.9-5.1-16.2-7.6-28.1-7.6c-8,0-14.8,1.1-20.3,3.4 c-5.5,2.2-9.8,5.3-12.7,9.3c-2.9,3.9-4.4,8.4-4.4,13.4c-0.2,4.2,0.7,7.8,2.7,10.9c1.9,3.1,4.6,5.8,8,8c3.4,2.2,7.3,4.2,11.8,5.8 c4.5,1.6,9.2,3,14.3,4.1l20.9,5c10.2,2.3,19.5,5.3,28,9.1c8.5,3.8,15.8,8.4,22,14c6.2,5.5,11,12,14.5,19.5 c3.4,7.5,5.2,16.1,5.3,25.8c-0.1,14.2-3.7,26.6-10.9,37c-7.2,10.4-17.5,18.5-30.9,24.2c-13.4,5.7-29.6,8.6-48.6,8.6 c-18.8,0-35.1-2.9-49-8.6c-13.9-5.8-24.7-14.3-32.5-25.6c-7.8-11.3-11.8-25.4-12.2-42.1h47.6c0.5,7.8,2.8,14.3,6.8,19.5 c4,5.2,9.3,9.1,16,11.7s14.3,3.9,22.8,3.9c8.3,0,15.6-1.2,21.8-3.6c6.2-2.4,11-5.8,14.4-10.1c3.4-4.3,5.1-9.3,5.1-14.9 c0-5.2-1.5-9.6-4.6-13.2c-3.1-3.6-7.5-6.6-13.4-9.1c-5.9-2.5-13-4.8-21.5-6.8l-25.3-6.4c-19.6-4.8-35.1-12.2-46.5-22.4 c-11.4-10.2-17-23.8-16.9-41c-0.1-14.1,3.7-26.4,11.3-36.9c7.6-10.5,18.1-18.8,31.4-24.7c13.3-5.9,28.5-8.9,45.5-8.9 c17.3,0,32.4,3,45.3,8.9c12.9,5.9,23,14.1,30.2,24.7c7.2,10.5,10.9,22.7,11.1,36.6H372.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M444.3,556.9V324.2h49.2v96h99.9v-96h49.1v232.7h-49.1v-96.1h-99.9v96.1H444.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShIcon);
export default __webpack_public_path__ + "static/media/sh_icon.07030e6032ac54fbc911e6a10668e29c.svg";
export { ForwardRef as ReactComponent };